module.exports = {"id":"185394","name":"Vegard Forren","rating":"72","photo":"./data/images/photos/1/185394.png","club":{"name":"Molde FK","logo":"./data/images/clubs/MoldeFK.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VegardForren0.json
// module id = 4241
// module chunks = 0